<template>
    <CRow>
        <CCol col="12" lg="8" xl="6">
            <img v-if="blok.shadow" :src="blok.pic" :width="blok.width" :class="this.$func.storyblok2Css(blok, 'mb-3 shadow')" />
            <img v-else :src="blok.pic" :width="blok.width" :class="this.$func.storyblok2Css(blok, 'mb-3')" />
            <div v-if="blok.description && blok.description.length > 0" class="mb-3 text-small">
                <em>{{blok.description}}</em>
            </div>
        </CCol>
    </CRow>
</template>

<script>
    export default {
        props: ['blok']
    }
</script>